// extracted by mini-css-extract-plugin
module.exports = {"text":"ModalUpdate-module--text--8BCea","button":"ModalUpdate-module--button--3KI-o"};